// LAP-733 — i18n configuration (GE022)
// Frontend internationalisation: fr (source) / en / de / it / es / zh / ja / ar
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Source-of-truth (French) bundles. Other languages are loaded lazily
// via http(s) backend in production builds, but we ship the static bundles
// directly here so the SPA works offline / in tests without a CDN call.
import frCommon from './locales/fr/common.json'
import frLayout from './locales/fr/layout.json'
import enCommon from './locales/en/common.json'
import enLayout from './locales/en/layout.json'
import deCommon from './locales/de/common.json'
import deLayout from './locales/de/layout.json'
import itCommon from './locales/it/common.json'
import itLayout from './locales/it/layout.json'
import esCommon from './locales/es/common.json'
import esLayout from './locales/es/layout.json'
import zhCommon from './locales/zh/common.json'
import zhLayout from './locales/zh/layout.json'
import jaCommon from './locales/ja/common.json'
import jaLayout from './locales/ja/layout.json'
import arCommon from './locales/ar/common.json'
import arLayout from './locales/ar/layout.json'

export const SUPPORTED_LANGUAGES = ['fr', 'en', 'de', 'it', 'es', 'zh', 'ja', 'ar']

export const LANGUAGE_META = {
  fr: { code: 'fr', native: 'Français', flag: '🇫🇷' },
  en: { code: 'en', native: 'English', flag: '🇬🇧' },
  de: { code: 'de', native: 'Deutsch', flag: '🇩🇪' },
  it: { code: 'it', native: 'Italiano', flag: '🇮🇹' },
  es: { code: 'es', native: 'Español', flag: '🇪🇸' },
  zh: { code: 'zh', native: '中文', flag: '🇨🇳' },
  ja: { code: 'ja', native: '日本語', flag: '🇯🇵' },
  ar: { code: 'ar', native: 'العربية', flag: '🇸🇦', dir: 'rtl' },
}

const resources = {
  fr: { common: frCommon, layout: frLayout },
  en: { common: enCommon, layout: enLayout },
  de: { common: deCommon, layout: deLayout },
  it: { common: itCommon, layout: itLayout },
  es: { common: esCommon, layout: esLayout },
  zh: { common: zhCommon, layout: zhLayout },
  ja: { common: jaCommon, layout: jaLayout },
  ar: { common: arCommon, layout: arLayout },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true, // 'fr-FR' -> 'fr', 'en-US' -> 'en', etc.
    ns: ['common', 'layout'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      // Order: explicit user choice in localStorage > browser navigator > html lang
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
